import { TextInput, TextInputProps } from '@mantine/core'
import React from 'react'

const CustomTextInput = ({ value = '', ...other }: TextInputProps) => {
    return (
        <TextInput
            w={200}
            value={value}
            styles={{
                input: {
                    borderColor: 'var(--mantine-color-gray-2)',
                    textAlign: 'end',
                },
            }}
            {...other}
        />
    )
}

export default CustomTextInput
